/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBuilding = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 2v4h6v16H2V2zm4 6h-4v12h4zm-8 6v6h2V4H4v16h2v-6zm-2 2H8v4h2zm-2-6v2H6v-2zm4 0v2h-2v-2zM8 6v2H6V6zm4 0v2h-2V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBuilding as Building };
